// extracted by mini-css-extract-plugin
export var MuiPopperRoot = "x_bx";
export var MuiTooltipPopper = "x_by";
export var button = "x_bC";
export var icon = "x_n";
export var iconWrapper = "x_bB";
export var title = "x_V";
export var wrapper = "x_bz";